import { theme } from "@ovou-inc/ovou-ui";

// Shared style pieces for the app's underline-style react-selects (Dropdown,
// AddMembersModal's member combobox). react-select takes per-part style
// *functions*, so we export composable pieces each consumer spreads and tweaks.
//
// Loose record type: react-select v4 hands emotion `CSSObject`s to these
// functions; this keeps the helpers assignable to every per-part signature
// without importing emotion's transitive types.
type CSSObject = Record<string, any>;

export const underlineControlBase = (base: CSSObject): CSSObject => ({
  ...base,
  background: "transparent",
  border: "none",
  borderBottom: `1px solid ${theme.palette.ui.greys.grey3}`,
  borderRadius: 0,
  minHeight: "49px",
  boxShadow: "none",
});

export const selectMenuBase = (base: CSSObject): CSSObject => ({
  ...base,
  borderRadius: "10px",
  border: `1px solid ${theme.palette.ui.greys.grey4}`,
  boxShadow: "0px 6px 10px rgba(0, 0, 0, 0.12)",
  overflow: "hidden",
  zIndex: 2,
});

// tooltip z-index so the menu sits above Chakra Modal overlays.
export const selectMenuPortalBase = (base: CSSObject): CSSObject => ({
  ...base,
  zIndex: theme.zIndex.tooltip,
});

export const selectMenuListBase = (base: CSSObject): CSSObject => ({
  ...base,
  padding: "8px",
});

export const selectOptionBase = (
  base: CSSObject,
  isFocused: boolean,
): CSSObject => ({
  ...base,
  background: isFocused
    ? theme.palette.ui.greys.grey5
    : theme.palette.brand.primary.white,
  color: theme.palette.brand.primary.black,
  borderRadius: "6px",
  cursor: "pointer",
});

// Emotion-rendered, so it doesn't inherit Chakra's body font — spell it out.
export const selectPlaceholderBase = (
  base: CSSObject,
  color: string = theme.palette.ui.greys.grey1,
): CSSObject => ({
  ...base,
  color,
  fontFamily: "Inter",
  fontSize: "16px",
  fontWeight: 400,
});

export const hiddenIndicatorSeparator = (): CSSObject => ({ display: "none" });
